import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99989 3.50067C5.31255 3.45533 2.53322 5.33333 0.785885 7.25667C0.602474 7.46029 0.500977 7.72462 0.500977 7.99867C0.500977 8.27271 0.602474 8.53705 0.785885 8.74067C2.49522 10.6233 5.26655 12.5447 7.99989 12.4987C10.7332 12.5447 13.5052 10.6233 15.2159 8.74067C15.3993 8.53705 15.5008 8.27271 15.5008 7.99867C15.5008 7.72462 15.3993 7.46029 15.2159 7.25667C13.4666 5.33333 10.6872 3.45533 7.99989 3.50067Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 8C10.4999 8.49443 10.3531 8.97771 10.0784 9.38875C9.80357 9.79978 9.41307 10.1201 8.95625 10.3092C8.49942 10.4983 7.99678 10.5478 7.51187 10.4512C7.02696 10.3547 6.58156 10.1165 6.232 9.76687C5.88243 9.41721 5.6444 8.97175 5.54799 8.48682C5.45158 8.00188 5.50113 7.49925 5.69037 7.04247C5.8796 6.5857 6.20004 6.19529 6.61114 5.92062C7.02225 5.64594 7.50558 5.49934 8 5.49934C8.32839 5.49925 8.65357 5.56388 8.95697 5.68952C9.26036 5.81517 9.53603 5.99938 9.7682 6.23161C10.0004 6.46384 10.1845 6.73956 10.3101 7.04299C10.4356 7.34642 10.5002 7.67162 10.5 8Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
